// extracted by mini-css-extract-plugin
export default {"ticket":"ticket_ticket__8Zceo","ticketMiddleSection":"ticket_ticketMiddleSection__guWUH","ticketBottomSection":"ticket_ticketBottomSection__fLBVf"};